import React from 'react'
import PropTypes from 'prop-types'
import GroupsMenuItem from './Item'
import css from './styles.css'

const GroupsMenuView = ({ filters, selected, onItemClick }) => (
  <div className={css.listContainer}>
    <h1 className={css.title}>Patients With Appointments:</h1>
    <ul className={css.list}>
      {filters.map(item => (
        <GroupsMenuItem
          item={item}
          key={item.id}
          onClick={onItemClick}
          isSelected={item.id === selected.id}
          type="filters"
        />
      ))}
    </ul>
  </div>
)

GroupsMenuView.propTypes = {
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      param: PropTypes.string,
      value: PropTypes.func,
    }),
  ).isRequired,
  onItemClick: PropTypes.func.isRequired,
  selected: PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
  }).isRequired,
}

export default GroupsMenuView



// WEBPACK FOOTER //
// ./src/components/PatientGroups/GroupsMenu/View.js